import cn from "classnames";
import type { LoaderProps } from "./types";
import styles from "./point-loader.module.scss";

const PointLoader = ({ size = "medium", className }: LoaderProps) => (
  <div className={cn(styles["point-loader"], styles[size], className)}>
    <span className={styles.item} />
    <span className={styles.item} />
    <span className={styles.item} />
    <span className={styles.item} />
    <span className={styles.item} />
    <span className={styles.item} />
  </div>
);

export { PointLoader };
